<template>
  <div>
    <b-overlay
      :show="loading"
      rounded="lg"
    >
    <Side-bar-detail
      :isSidebarActive="isSidebarActive"
      :is-sidebar-active.sync="isSidebarActive"
      :data="pass_data"
      @clicked="one"
    />
    <b-row>
      <b-col
        cols="12"
        md="2"
        class="align-items-center justify-content-start mb-1 mb-md-0"
      >

      </b-col>
      <b-col
        cols="12"
        md="3"
        class="align-items-center justify-content-start mb-1 mb-md-0"
      >
    </b-col>
    <b-col
        cols="12"
        md="3"
        class="align-items-center justify-content-start mb-1 mb-md-0"
      ><v-select :clearable="false" :reduce="center => center.id" :options="centerOptions" v-model="center_filter"></v-select></b-col>
    
      <b-col
        cols="12"
        md="4"
      >
        <div class="d-flex align-items-center justify-content-end">

          <flat-pickr
          v-model="rangeDate"
          class="form-control mb-1 mr-1"
          :config="{ mode: 'range'}"
        />
          <b-button
            variant="primary"
            class="mb-1"
            @click="exportToExcel()"
          >
            <span class="text-nowrap">Export</span>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <!-- table -->
    <b-table
      ref="selectableTable"
      
      :select-mode="selectMode"
      :items="items"
      :fields="fields"
      responsive
      striped 
      class="mb-0"
    >

      <template #cell()="data">
        <span style="cursor: pointer;" @click="isSidebarActive = true;pass_data.data = data.item.detail;pass_data.key =  data.field.key "> {{ data.value }}</span>
      </template>
    </b-table>
  </b-overlay>
  </div>
  
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'
import SideBarDetail from './SideBarDetail.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BTable, BAvatar, BOverlay,BCardBody, BBadge,  BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BInputGroupPrepend,BModal, VBModal} from 'bootstrap-vue'
export default {
  components: {
    moment,BOverlay,
    SideBarDetail,
    flatPickr,
    BTable,
    ToastificationContent,
    BModal, VBModal,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BButton,
    BPagination,
    BCardCode,
    BTable,
    BButton,
    BFormGroup,
    BAvatar,
    BCardBody,
    BBadge,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      iframe_src : '//rb.cloudedu.pro/invoice.php',
      rangeDate: null,
      searchString: null,
      type:'all',
      test_string : null,
      isSidebarActive: false,
      headerTitle: [],
      headerVal: [],
      loading:false,
      pass_data:{
        key : null,
        data : null
      },
      genderOptions: [
        { label: 'Male', value: 'M' },
        { label: 'Female', value: 'F' },
      ],
      planOptions: [
        { label: 'Basic', value: 'basic' },
        { label: 'Company', value: 'company' },
        { label: 'Enterprise', value: 'enterprise' },
        { label: 'Team', value: 'team' },
      ],
      typeOptions: [
        { label: 'All', value: 'all' },
        { label: 'Membership', value: 'MEMBERSHIP' },
        { label: 'Product', value: 'PRODUCT' },
        { label: 'Package', value: 'PACKAGE' },
        { label: 'Rental', value: 'RENTAL' }
      ],
      statusOptions: [
        { label: 'Active', value: 'active' },
        { label: 'Disabled', value: 'disabled' },
      ],
      centerOptions: [],
      isAddNewMemberSidebarActive: false,
      searchString: null,
      perPage: 10,
      startRow: 1,
      center_filter:'',
      endRow: 10,
      total: [],
      pageOptions: [10, 15, 20],
      totalRows: 1,
      currentPage: 1,
      fields: [{ key: 'center_name', label: 'Centre' }],
      /* eslint-disable global-require */
      items: [],
      /* eslint-disable global-require */
      status: [{
        1: 'Active', 2: 'Disabled', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        1: 'light-success', 2: 'light-danger', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
      selectMode: 'single',
      selected: [],
    }
  },
  watch: {
    center_filter: {
      handler(newValue, oldValue) {
        this.get_data()
      },
    },
    type: {
      handler(newValue, oldValue) {
        this.get_data()
      },
    },
    rangeDate : {
      handler(newValue, oldValue) {
        this.get_data()
      },
    },
    currentPage: {
      handler(newValue, oldValue) {
        this.get_data()
      },
    },
    searchString: {
      handler(newValue, oldValue) {
        // console.log("search")
        this.searchString = newValue.toUpperCase()
        this.handleSearch()
      },
    },
    perPage: {
      handler(newValue, oldValue) {
        if (newValue < 9) {
          this.perPage = 10
        }
        // console.log("search")
        this.handleSearch()
      },
    },
  },
  created() {
    this.get_data()
    this.get_grade_data()
    this.get_center_data()
  },
  methods: {
    get_center_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
        .then(res => {
          this.centerOptions = res.data.centers
        })
    },
    one() {
        this.isSidebarActive = false
        },
        exportToExcel() {
        console.log(this.fields)
        var fieldTitle = []
        var fieldValue = []
            this.fields.forEach((item, i) => {
                fieldTitle.push(item.label)
                fieldValue.push(item.key)
            })

            

        import('@/@core/Export2Excel').then(excel => {
          const list = this.items
          const data = this.formatJson(fieldValue, list)

          excel.export_json_to_excel({
            header: fieldTitle,
            data,
            filename: 'Grade_'+this.rangeDate,
            autoWidth: true,
            bookType: 'xlsx'
          })
          //this.clearFields()
        })
      },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          // Add col name which needs to be translated
          // if (j === 'timestamp') {
          //   return parseTime(v[j])
          // } else {
          //   return v[j]
          // }

          return v[j]
        })
      )
    },
    get_data(searchString = null) {
      this.loading = true
      var splitted = []
      if (this.rangeDate === null) {
        splitted[0] = moment().startOf('month').format('YYYY-MM-DD')
        splitted[1] = moment().endOf("month").format("YYYY-MM-DD")
        this.rangeDate = moment().startOf('month').format('YYYY-MM-DD') + " to " + moment().endOf("month").format("YYYY-MM-DD")
      } else {
        splitted = this.rangeDate.split(" to ");
      }
      this.$http.get(process.env.VUE_APP_API_BASE+`/report/grade/?center=`+this.center_filter+`&from=`+splitted[0]+`&to=`+splitted[1])
        .then(res => {
          if (res.data.result === false) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
            this.loading = false
          } else {
            this.items = res.data
            this.loading = false
              this.items.forEach((item , index) => {
                  this.total
              })
            
          }
        })
    },
    get_center_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
        .then(res => {
          this.centerOptions = res.data.centers
        })
    },
    get_grade_data() {
      let temp = { "key" : "trial","label" : "TL", sortable: true }
      this.fields.push(temp)
      temp = { "key" : "short_course","label" : "WS" , sortable: true}
      this.fields.push(temp)
      this.$http.get(process.env.VUE_APP_API_BASE+'/grades/')
        .then(res => {
            //console.log(res)
            res.data.grades.forEach((grade , index) => {
                let temp = { "key" : grade.code , sortable: true,"label" : grade.code}
                this.fields.push(temp)
            })
        })
        
    },
    handleChangePage() {

    //  this.get_data()
    },
    onRowSelected(items) {
      this.selected = items[0]
      this.iframe_src = '//rb.cloudedu.pro/pdf/INVOICE_'+items[0].code+'.pdf'
      this.transaction_id = items[0].transaction_id
      this.$refs['my-modal'].show()
    },
    close() {
      this.iframe_src = '//www.cloudfit.pro/invoice.php'
      this.$refs['my-modal'].hide()
      this.clearSelected()
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    selectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.selectRow(2)
    },
    unselectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.unselectRow(2)
    },

    handleSearch() {
      // let _print = `The user searched for: ${searching}\n`
      // this.$refs.pre.appendChild(document.createTextNode(_print))
    // this.searchString = searching
    // this.currentx = 1
    // this.get_data()
      this.searchTimeOut()
    },
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        // your code
        this.currentPage = 1
        this.get_data(this.searchString)
      }, 500)
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style lang="scss">
.b-table-selectable{
  .feather{
    font-size: 1.3rem;
  }
}

</style>
